import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { find } from 'lodash';
import { CountriesService } from '../../services/countries.service';

@Component({
  selector: 'sc-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss'],
})
export class PhoneInputComponent implements OnChanges {
  @Input() disabled: any;
  @Input() number: any;
  @Output() change = new EventEmitter();

  // mask;
  // numberWithoutMask;
  countries;
  selectedCountry;

  constructor(private countriesService: CountriesService) {
    this.countries = this.countriesService.countries;
    this.number = this.number || '';
    this.selectedCountry = this.countries[0];
  }

  ngOnChanges() {
    this.getSelectedCountry();
  }

  getSelectedCountry() {
    if (this.number && this.number.length) {
      this.selectedCountry = find(this.countries, country => {
        return this.number.indexOf(country.phone_prefix) === 0;
      });
    }
    this.selectedCountry = this.selectedCountry || this.countries[0];
    // const prefix = this.selectedCountry.phone_prefix;
    // this.numberWithoutMask = this.number ? this.number.substring(prefix.length) : '';
  }

  displaySelected(item) {
    return item.phone_prefix;
  }

  // onCountryChanged(code) {
  //   this.selectedCountry = find(this.countries, country => country.phone_prefix === code);

  //   this.number = '';
  //   this.onValueChanged(this.number);
  // }

  // getMask() {
  //   return {
  //     mask: this.selectedCountry.phone_mask,
  //   };
  // }

  onValueChanged(value) {
    // const number = value.replace(/[-_()\s]/g, '');
    // this.change.emit(this.selectedCountry.phone_prefix + number);
    this.change.emit(this.number);
  }
}
